
<template>
  <v-dialog v-model="dialog" transition="dialog-bottom-transition" scrollable>
    <template v-if="!hideButton" v-slot:activator="{ props }">
      <v-btn color="primary" :class="{ 'float-right': floatRight }" v-bind="props" density="compact">
        <v-icon class="mr-2">mdi-plus</v-icon>
        Novo cadastro
      </v-btn>
    </template>
    <v-card>
      <v-toolbar color="primary" title="Novo cadastro">
        <v-btn color="black" @click="dialog = false" density="compact">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <FormularioCadastro
                            :group_id="group_id"
                            :user="user"
                            :me="fakeMe"
                            :new="true"
                            :admin="admin"
                            :person-type="personType"
                            @updated="createdLegalPerson" />
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn variant="text" color="error" @click="dialog = false" density="compact">
          Cancelar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import FormularioCadastro from './FormularioCadastro.vue';
import api from '@/services'
export default {
  name: "Copyright",
  components: { FormularioCadastro },
  props: {
    user: Object,
    floatRight: Boolean,
    fakeMe: Object,
    admin: Boolean,
    dialogStatus: Boolean,
    hideButton: Boolean,
    group_id: Number,
    personType: Number,
  },
  data() {
    return {
      dialog: false,
    };
  },
  mounted() { },
  activated() { },
  emits: ['updated', 'closed'],
  methods: {
    createdLegalPerson(legal_person) {
      this.$emit('updated', legal_person);
    }
  },
  computed: {},
  watch: {
    dialog(newVal) {
      const vm = this;
      if (newVal && !api.storage.isGroupSelected()) {
        vm.$notify({
          type: "warn",
          text: "Selecione um grupo se quiser salvar o cadastro",
        });
      }
      if (!newVal) {
        vm.$emit('closed')
      }
    },
    dialogStatus(newVal) {
      const vm = this;

      vm.dialog = newVal;
    }
  }
};
</script>
